import gameset from './gameset.js';
import TouchZoneBase from '../framework/src/modules/TouchZoneBase';
import * as PIXI from "pixi.js-legacy";
import Commander from "./Commander";
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";

export default class TouchZone extends TouchZoneBase {

    constructor (config, layers, slots, wallet, symbols, audio, infoPages) {
        super(config, layers, slots, wallet, symbols, gameset);
        this.config = config;
        this.layers = layers;
        this.slots = slots;
        this.infoPages = infoPages;
        this.audio = audio;

        this.layerBlack = this.layers.black;
    }

    /**
     *   gameset['game']['layers'][
     *     'black',    - black layer to darken other symbols when clicked
     *      'touchZone' - zones are added here
     *   ];
     *   gameset['game']['symbolModel']['touchZone']: {
     *       width :    - width of the touch zone, center aligned with the symbol
     *       height :   - height of the touch zone, center aligned with the symbol
     *       reels :    - array of the LENGTH defined by the reel COLUMNS COUNT, values [left|right], sets to what side is the frame shifted
     *       table :    - name of the winFactor frame image
     *       numbers :  - name of the winFactor numbers image
     *       font :     - name of the font used
     *       factors :  - amount of non-zero factors
     *   }
     *
     *  HOW TO USE TOUCHZONE:
     *  1. Set all gameset fields ^^ in gameset.js
     *  2. Create layers touchZone and winFactors and add them to gameset
     *  3. Rewrite drawFrame() function. use shiftSprite to position elements (don't forget both orientations!).
     *  4. Access elements using:
     *          -   this.winFactorFrame
     *          -   this.winFactorNumbers
     *          -   this.winFactorSprite
     *          -   this.factorOnSymbols[]
     *  5. When you start spinning and when the round ends use zonesOn(), zonesOff() to disable winFactors during spinning
     *
     */

    /**
     * @override
     * @params symbol - one of the resSymbols that was clicked on, data type is Sprite
     *         orientation - to what side you should shift the frame, values "left" or "right"
     */
    drawFrame(symbol, orientation) {
        if (this.infoPages.isHided || this.config.get(CONFIG_PARAMS.SEPARATED_INFOPAGES)) {

            this.creditBet = this.wallet.getCreditBet();

            this.layers.winFactors.alpha = 1;

            if (orientation === "left")
                this.shiftSprite(this.winFactorFrame,symbol.x, symbol.y , -70);
            else
                this.shiftSprite(this.winFactorFrame,symbol.x, symbol.y , +70);

            this.winFactorSprite.destroy();
            this.winFactorSprite = this.factory.createByIndex(symbol.symbolIndex, {});
            this.layers.winFactors.addChild(this.winFactorSprite);
            this.winFactorSprite.position.set(symbol.x, symbol.y);

            if (orientation === "left")
                this.shiftSprite(this.winFactorNumbers,symbol.x, symbol.y , -215);
            else
                this.shiftSprite(this.winFactorNumbers,symbol.x, symbol.y , +130);


            
            let i = 0;
            let factors = this.getSymbolFactor(symbol.name).factors;
            for (let factor of this.factorOnSymbols) {
                factor.text = factors[factors.length-i-1]*this.creditBet + "";
                if (orientation === "left"){
                    this.shiftSprite(factor ,symbol.x, symbol.y , -120, -69+41*i);
                }
                else
                    this.shiftSprite(factor ,symbol.x, symbol.y , +225, -69+41*i);
                i++;
            }
        }
    }

    /**
     * @override
     */
    onPointerDown() {
        Commander.setAlpha(this.layerBlack, .7, 100);
        this.audio.playTrack("ui_Btn_WinFactors");
    }

    /**
     * @override
     */
    onPointerUp() {
        Commander.setAlpha(this.layerBlack, 0, 100);
    }

}